
// React drill-down demo... https://codesandbox.io/s/highcharts-react-demo-uti0o

import React from "react";
import { render } from "react-dom";
import $ from "jquery";
// Import Highcharts
import Highcharts from "highcharts/highmaps";
import drilldow from "highcharts/modules/drilldown";
import dataModule from "highcharts/modules/data";
//import mapData from "./mapData";

import HighchartsReact from "highcharts-react-official";

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

import { differenceInDays, addDays, getMonth, addMonths, getDaysInMonth, format } from 'date-fns'

import Button from '@material-ui/core/Button';
import MyLocationIcon from '@material-ui/icons/MyLocation';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';


dataModule(Highcharts);


//Highcharts.getJSON('https://cdn.jsdelivr.net/gh/highcharts/highcharts@v7.0.0/samples/data/world-population-density.json', function (data) {

// var data = Highcharts.geojson(Highcharts.maps["countries/us/us-all"]),
//   separators = Highcharts.geojson(
//     Highcharts.maps["countries/us/us-all"],
//     "mapline"
//   );


const useStyles = makeStyles((theme) => ({
    root: {
      width: 800,
    },
    margin: {
      height: theme.spacing(3),
    },
  }));
  
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 30); //new Date('2020-01-27');

  
  var Difference_In_Days = differenceInDays(endDate, startDate); 

  let date = new Date(startDate);

  const marks = [];
  let i = 0;
  let prevDate = new Date(date);

  while (date <= endDate)
  {
    //console.log(prevDate, date, getMonth(prevDate), getMonth(date));
      // if (i == 0 || getMonth(prevDate) !== getMonth(date))
      // {
      //   marks.push({value: i, label: format(date, 'MMM') });
      // }
      
      if (i%2 === 0)
      {
        marks.push({value: i, label: format(date, 'MMM dd') });
      }
      prevDate = new Date(date);
      date = addDays(date, 1);
      i++;

  }

  console.log(marks);

  
  function valuetext(value) {
    return `${value}°C`;
  }


  const attTypes =
  {
    cases: {name: 'Total Cases', calc: (county, offset) => county.c[offset]},
    cases_per_100k: {name: 'Cases per 100K', calc:  (county, offset) => (county.c[offset]/county.population) * 100000},
    cases_growth: {name: "Week's Growth", calc:  (county, offset) => ((county.c[offset] - county.c[offset-7]) / county.c[offset-7]) * 100, isPercent: true},
    //deaths: {name: 'Total Deaths', calc: (county, offset) => county.d[offset]},
  }





window.Highcharts = Highcharts;
const mapRef1 = React.createRef();

  const USMap = (props) =>  
  {



    // https://code.highcharts.com/mapdata/countries/us/us-all-all.geo.json
    const [mapFeatures, setMapFeatures] = React.useState(null);
    const [mapData, setMapData] = React.useState(null);
    const [currentDateOffset, setCurrentDateOffset] = React.useState(28);
    const [selectedTheme, setSelectedTheme] = React.useState('cases_per_100k');

      //https://stackoverflow.com/questions/55154186/react-hooks-usestateuseeffectevent-gives-stale-state
      //https://dev.to/anpos231/react-hooks-the-closure-hell-71m
      let refValue = React.useRef({currentDateOffset});
      React.useEffect(() => {
          refValue.current = {currentDateOffset};
      });


    // React.useEffect(() => 
    // {
    //     async function fetchData() 
    //     {
    //       // loadUsaMap();
    //     }
    //     fetchData();
    // }
    // , []);

    React.useEffect(() => 
    {
        if (mapData !== null)
        {
            loadCasesByDate();
        }
    }
    , [mapData]);

    React.useEffect(() => 
    {
        if (mapData !== null)
        {
            loadCasesByDate()
        }
    }
    , [currentDateOffset]);

    React.useEffect(() => 
    {
        if (mapData !== null)
        {
            loadCasesByDate()
        }
    }
    , [selectedTheme]);

    React.useEffect(() => 
    {
      loadUsaMap();
      loadCovidData();
    }
    , []);

    
    const getAttValue = (county, type) =>
    {
      return attTypes[type].calc(county, refValue.current.currentDateOffset);
    }

    const getFormattedAttValue = (county, type) =>
    {
      type = attTypes[type];
      const val = type.calc(county, refValue.current.currentDateOffset);
      const decimals = (type.decimals !== undefined) ? type.decimals : 0;
      const isPercent = (type.isPercent !== undefined) ? type.isPercent : false;
      let str = Highcharts.numberFormat(val , decimals, '.', ',');
      if (isPercent === true)
      {
        str = str + '%';
      }
      return str;
    }

    const loadCovidData = () =>
    {
       // fetch('https://code.highcharts.com/mapdata/countries/us/us-all.geo.json')
        //fetch('http://localhost/getCountyCases?date=2020-03-28')
        //fetch('http://localhost/getCountyCases?date=2020-03-28')
        //fetch('./nyt_denormalized.json')
        fetch('https://covid-19-panel.storage.googleapis.com/nyt_denormalized')
        //fetch('https://cdn.jsdelivr.net/gh/highcharts/highcharts@c116b6fa6948448/samples/data/us-counties-unemployment.json')
        
        .then(response => response.json())
        .then((jsonData) => {
        // jsonData is parsed json object received from url
  
        //setMapData(jsonData);

        //options.series[0].mapData = jsonData;
//        console.log(jsonData);
        setMapData(jsonData);
        //mapRef1.current.chart.series[0].update(options.series[0]);
        //mapRef1.current.chart.series[0].update({data: jsonData});
        //mapRef1.current.chart.series[0].setData(jsonData);


        // const minDateStr = '2020-01-27';
        // const minDate = new Date(minDateStr);
        // const currDate = new Date();
      
        // console.log(minDate, currDate);
        // let date = new Date(minDate);
        // do 
        // {
        //   console.log('date = ', date);
        //   date.setDate(date.getDate() + 1);
        // } while(date < currDate);
      



        })
        .catch((error) => {
        // handle your errors here
        console.error(error)
        })
    }

    function waitForChart(newData) //https://stackoverflow.com/questions/22125865/wait-until-flag-true
    {
      if(! mapRef1.current) {
         window.setTimeout(() => waitForChart(newData), 500); /* this checks the flag every 100 milliseconds*/
      } else {
        mapRef1.current.chart.series[0].setData(newData);

      }
  }

    const loadCasesByDate = () =>
    {
      const newData = [...mapData];
      //console.log(newData);
      newData.forEach(county => 
      {
        //const val = county.c[offset];
        //const val = (county.c[currentDateOffset] / county.population) * 100000;
        const val = getAttValue(county, selectedTheme);
        county.value = (val >= 0) ? val : null;
      });
      waitForChart(newData);
    }

    const loadUsaMap = () =>
    {

       // fetch('https://code.highcharts.com/mapdata/countries/us/us-all.geo.json')
        //fetch('http://localhost/getCountyCases?date=2020-03-28')
        //fetch('http://localhost/getCountyCases?date=2020-03-28')
        //fetch('./nyt_denormalized.json')
        fetch('https://covid-19-panel.storage.googleapis.com/us-all-all.geo.json')
        //fetch('https://cdn.jsdelivr.net/gh/highcharts/highcharts@c116b6fa6948448/samples/data/us-counties-unemployment.json')
        
        .then(response => response.json())
        .then((jsonData) => {
        // jsonData is parsed json object received from url
  
        //setMapData(jsonData);

        //options.series[0].mapData = jsonData;
        console.log(jsonData);
        setMapFeatures(jsonData);
        //mapRef1.current.chart.series[0].update(options.series[0]);
        //mapRef1.current.chart.series[0].update({data: jsonData});
        //mapRef1.current.chart.series[0].setData(jsonData);


        // const minDateStr = '2020-01-27';
        // const minDate = new Date(minDateStr);
        // const currDate = new Date();
      
        // console.log(minDate, currDate);
        // let date = new Date(minDate);
        // do 
        // {
        //   console.log('date = ', date);
        //   date.setDate(date.getDate() + 1);
        // } while(date < currDate);
      



        })
        .catch((error) => {
        // handle your errors here
        console.error(error)
        })
    }

    // options.series[0].data = [{'postal-code': 'AZ', cases: 100},];
    // options.series[0].mapData = Highcharts.maps["countries/us/us-all"];

    const options = {
      lang: {
        decimalPoint: '.',
        thousandsSep: ',',
        shared: true
      },
        chart: {
           // borderWidth: 1,
            marginRight: 20, // for the legend
            width: 1100,
            height: 700,
        },

        mapNavigation: {
            enabled: true,
            enableMouseWheelZoom: false,
        },
        colorAxis: {
            //min: 0,
            //max: 2000,
            visible: false,
            tickInterval: 5,
            stops: [[0, '#F1EEF6'], [.02, '#ffe0ed'], [0.25, '#900037'], [1, '#500007']],
            labels: {
               // format: '{value}%'
            }
        },

        title: {
          //text: 'Counties',
          text: null,
        },

        tooltip: {
          useHTML: true,
            formatter: function () {
             // return this.point.name + ', ' + this.point.properties['hc-key'].split('-')[1].toUpperCase();


              let str = '<table><tr><td colspan="2"><b>' + this.point.name + ' County, ' + this.point.properties['hc-key'].split('-')[1].toUpperCase() + '</b></td></tr>';
              for (let key of Object.keys(attTypes))
              {
                str += '<tr><td>' + attTypes[key].name + ':</td><td style="text-align: right;">' + getFormattedAttValue(this.point, key) + '</td></tr>';
              }
              str += '</table>';
              /*
              '<tr><td>Cases:</td><td style="text-align: right;">' + Highcharts.numberFormat(attTypes.cases(this.point, currentDateOffset) , 0, '.', ',') + '</td></tr>' +
              '<tr><td>Cases per 100K:</td><td style="text-align: right;">' + Highcharts.numberFormat(attTypes.cases_per_100k(this.point, currentDateOffset) , 0, '.', ',') + '</td></tr>' +
              '<tr><td>Growth:</td><td style="text-align: right;">' + Highcharts.numberFormat(attTypes.cases_growth(this.point, currentDateOffset) , 0, '.', ',') + '</td></tr>' +
              '<tr><td>Deaths:</td><td style="text-align: right;">' + Highcharts.numberFormat(attTypes.deaths(this.point, currentDateOffset) , 0, '.', ',') + '</td></tr>' +
              "</table>"
              ;
              */

                return str;
            }
        },
      
        series: [
          {
            //data: [{'postal-code': 'AZ', cases: 100},],
            //mapData: Highcharts.maps["countries/us/us-all"],
            mapData: mapFeatures, //Highcharts.maps["countries/us/us-all-all"],
            joinBy: ['fips', 'f'],
            name: "USA",
            // dataLabels: {
            //     enabled: true,
            //     color: '#FFFFFF',
            //     allowOverlap: true,
            //     //format: '{point.name}',
            //     formatter: function(){
                  
            //         var e = this.series.xAxis.getExtremes();
            //         const diff = e.max - e.min;

            //         //console.log('rrrrrrrrrrrrrrrrr', diff, this);
                    
            //         if (e.max - e.min < 1000)
            //             return this.key;
                        
            //         return null;
            //     }
            // },
            // dataLabels: {
            //   enabled: true,
            //   format: "{point.properties.postal-code}"
            // }
          },
          // {
          //   type: "mapline",
          //   data: separators,
          //   color: "silver",
          //   enableMouseTracking: false,
          //   animation: {
          //     duration: 500
          //   }
          // }
        ],
      
      };


    return <div style={{border: '1px solid whitesmoke', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>

        <div style={{width: 1000, padding: 30}}>
          <Slider
            defaultValue={Difference_In_Days}
            getAriaValueText={valuetext}
            aria-labelledby="discrete-slider-always"
            step={1}
            marks={marks}
            valueLabelDisplay="on"
            valueLabelFormat={num => addDays(startDate, num).getDate()}
            min={0}
            max={Difference_In_Days}
            style={{margin: 30}}
            onChangeCommitted={(event,num) => setCurrentDateOffset(num-1)}
            //onChange={(event,num) => loadCasesByDate(num-1)}
            //track={false}
            />

          <FormControl component="fieldset">
            {/* 
            <FormLabel component="legend">Gender</FormLabel>
            */}
            <RadioGroup aria-label="gender" name="gender1" value={selectedTheme} onChange={evt => setSelectedTheme(evt.target.value)} row>
              {
                Object.keys(attTypes).map(key => <FormControlLabel value={key} control={<Radio />} label={attTypes[key].name} />)
              }
            </RadioGroup>
          </FormControl>
        </div>
        <br/>
        <div>
        {
          (mapFeatures)
          ?
          <HighchartsReact
          highcharts={Highcharts}
          options={options}
          constructorType={"mapChart"}
          allowChartUpdate={false}
          ref={mapRef1}
          />
          :
          null
        }
        </div>
    </div>
  }
  
  

  export default USMap